<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="发布者">
                    <el-input v-model="queryParams.username" placeholder="请输入发布者" clearable></el-input>
                </el-form-item>
                <el-form-item label="话题">
                    <el-select v-model="queryParams.column_id" placeholder="请选择话题" clearable @change="changeQuery">
                        <el-option v-for="item in topicList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="queryParams.title" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="上线" :value="2">上线</el-option>
                        <el-option label="下线" :value="1">下线</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="queryParams.is_video" placeholder="请选择类型" clearable @change="changeQuery">
                        <el-option label="视频" :value="1">视频</el-option>
                        <el-option label="文章" :value="0">文章</el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <el-radio-group v-model="tabPosition" style="margin-bottom: 30px" @input='selColunm'>
                <el-radio-button :label="index" v-for="(item,index) in colunmList" :key="index">{{item.name}}</el-radio-button>
            </el-radio-group>

            <div class="list_boxs">
                <div class="list_item" v-for="item in pageInfo.list" :key="item.id" @click="ItemDetail(item)">
                    <img :src="item.thumb" class="img" alt="" />
                    <div class="center_box">
                        <div class="title">{{ item.title }}</div>
                        <div class="tag">
                            <el-tag style="margin-right:5px;" v-for="(val,valindex) in item.commonTag" :key="valindex" :type='tagTpey(valindex)'>{{val.name}}</el-tag>

                        </div>
                        <div class="time">{{item.created_at}}</div>
                    </div>
                </div>
            </div>

            <el-drawer title="" :visible.sync="drawer" :with-header="true" size="40%">
                <div class="detail_box">
                    <el-button type="primary" @click="copy">复制内容</el-button>

                    <div class="title">{{ selectedArticle.title }}</div>
                    <p v-html="selectedArticle.content" id="html"></p>
                </div>
            </el-drawer>

            <!--            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="发布者">
                    <el-input v-model="queryParams.username" placeholder="请输入发布者" clearable></el-input>
                </el-form-item>
                <el-form-item label="话题">
                    <el-select v-model="queryParams.column_id" placeholder="请选择话题" clearable @change="changeQuery">
                        <el-option v-for="item in topicList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="queryParams.title" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryParams.state" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="上线" :value="2">上线</el-option>
                        <el-option label="下线" :value="1">下线</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="queryParams.is_video" placeholder="请选择类型" clearable @change="changeQuery">
                        <el-option label="视频" :value="1">视频</el-option>
                        <el-option label="文章" :value="0">文章</el-option>
                    </el-select>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>

            </el-form>-->
            <!-- 表格内容 -->
            <!--            <el-table :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable">
                <el-table-column prop="id" label="id" width="auto" align="center">
                    <template slot-scope="scope">
                        <el-row>
                            <el-col :span="3">
                                <el-image @click="showBigImg(scope.$index,'img1')" fit="cover" class="head_img" :class="`img1column${scope.$index}` " :src="scope.row.thumb" :preview-src-list="[scope.row.thumb]">
                                    <div slot="error" class="image-slot">
                                        <el-image :src="defaultImg" class="center_image"></el-image>
                                    </div>
                                </el-image>
                            </el-col>
                            <el-col :span="20">
                                <el-row>
                                    {{ scope.row.title}}
                                </el-row>
                                <el-row>
                                    <el-tag v-for="(item,index ) in scope.row.tag" :key="index">{{item.name}}</el-tag>
                                </el-row>
                                <el-row>
                                    {{ scope.row.ctime}}
                                </el-row>
                            </el-col>

                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="500" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 2" type="text" class="red" @click="state(scope.row, 1)">下线
                        </el-button>
                        <el-button v-if="scope.row.state === 1" type="text" class="green" @click="state(scope.row, 2)">
                            上线</el-button>
                    </template>
                </el-table-column>
            </el-table>-->
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
            <!-- 上线、下线提示框 -->
            <el-dialog title="提示" :visible.sync="confirmVisible" width="300px" center>
                <div class="del-dialog-cnt">{{ confirmContent }}</div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="confirmVisible = false">取 消</el-button>
                    <el-button type="primary" @click="stateData">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import { request } from '@/common/request';
import { deal } from '@/common/main';
import clipboard from 'clipboard-all';
import $ from 'jquery'
export default {
    name: 'seller',
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            defaultImg: require('../../assets/img/zhan.jpeg'),
            topicList: [],
            options: [
                {
                    value: '2',
                    label: '可用'
                },
                {
                    value: '0',
                    label: '不可用'
                }
            ],
            pageInfo: {},
            value: '',
            form: {},
            confirmVisible: false,
            menuList: ['社区', '文章管理'],
            confirmContent: '',
            queryParams: {
                page: 1,
                pagesize: 10,
                article_column_id: null,
            },

            tabPosition: 0,

            selectedArticle: {},
            drawer: false,
            html: '',

            agent_id: null,
            colunmList: [],
        };
    },

    watch: {
        $route(to, from) {
            let ArticleEdit = from.fullPath.indexOf('/community-ArticleEdit');
            let ArticleAdd = from.fullPath.indexOf('/community-ArticleAdd');
            if (ArticleEdit !== -1 || ArticleAdd !== -1) {
                this.loadData();
            }
        }
    },
    created() {
        // console.log(this.form)
        this.getTopic();
        this.loadData();
        this.getColumn();
        this.agent_id = JSON.parse(localStorage.getItem('user')).uid;

    },
    mounted() {

    },
    methods: {
        add() {
            this.$router.push({ path: '/community-ArticleAdd' });
        },

        setWXPath() {
            let pathDom = document.querySelectorAll('.weapp_image_link');
            console.log(pathDom, 'DOM')
            for (let i = 0; i < pathDom.length; i++) {
                let path = pathDom[i].getAttribute('data-miniprogram-path');
                pathDom[i].setAttribute('data-miniprogram-path', path + `?agent_id=${this.agent_id}`);
            }
        },

        setWanEditionWX() {
            let wxImglist = document.querySelectorAll('img');
            wxImglist.forEach(item => {
                let path = item.getAttribute('data-href');
                if (path && path.includes('data-miniprogram-appid')) {
                    let srcStirng = path.slice(1, path.length - 1);
                    let srcArr = srcStirng.split(',');
                    let parentNode = document.createElement('a');//创建节点
                    srcArr.forEach(val => {
                        let arr = val.split(':');
                        arr.forEach((i, index) => {
                            if (i == 'data-miniprogram-path') {
                                arr[index + 1] += `?agent_id=${this.agent_id}`
                            }
                        })
                        parentNode.setAttribute(`${arr[0]}`, `${arr[1]}`);   // 设置属性
                    })
                    parentNode.setAttribute('data-miniprogram-nickname', '鲤好惠选');
                    parentNode.classList.add('weapp_image_link');

                    item.parentNode.replaceChild(parentNode, item);//获取子元素原来的父元素并将新父元素代替子元素
                    parentNode.appendChild(item);//  在新父元素下添加原来的子元素

                }
            })
        },

        // 获取栏目
        getColumn() {
            request.get('/community/article/column/list', { page: 1, pagesize: 9999 }).then(ret => {
                if (ret.code == 1) {
                    let list = ret.data.list;
                    let obj = {
                        id: 0,
                        name: '全部',
                    }
                    list.unshift(obj);
                    this.colunmList = list;

                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 选择的栏目
        selColunm(val) {
            console.log(val, '栏目')
            let colunm = this.colunmList[val];
            if (colunm.id == 0) {
                this.queryParams.article_column_id = null;
            } else {
                this.queryParams.article_column_id = colunm.id;
            }
            this.loadData();
        },

        getTopic() {
            request.get('/community/column/list').then((ret) => {
                if (ret.code == 1) {
                    this.topicList = ret.data.list;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        mapFortopic(row) {
            let map = [];
            if (this.topicList && this.topicList.length) {
                this.topicList.forEach((item) => {
                    if (item.id === row.column_id) {
                        map[item.id] = item.name;
                    }
                });
            }
            return map;
        },
        // 详情
        ItemDetail(item) {
            this.selectedArticle = item;
            console.log(item);
            this.drawer = true;

            this.$nextTick(() => {
                this.setWanEditionWX();
            })

        },
        loadData() {
            this.loading = true;
            const _this = this;
            // 获取文章列表数据
            request.get('/community/article/list', this.queryParams).then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function(val) {
                        val.stime = deal.timestamp(val.stime, 'unix');
                        return val;
                    });
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 查看大图
        showBigImg(index, node) {
            this.$nextTick(function() {
                let shows = document.getElementsByClassName(`${node}column${index}`);
                let show = shows[0].getElementsByClassName('el-image-viewer__wrapper');
                show[0].style['display'] = 'block';
                let dom = show[0].getElementsByClassName('el-image-viewer__mask');
                dom[0].addEventListener('click', function() {
                    show[0].style['display'] = 'none';
                });
            });
        },
        // 分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        // 图片上传
        handleAvatarSuccess(res, file) {
            if (res.code == 1) {
                this.$set(this.form, 'avatar', res.data.uri);
            }
        },
        beforeAvatarUpload(file) {
            const _this = this;
            return deal.imageFormat(file, _this);
        },
        edit(index, row) {
            this.title = '基本信息';
            this.current = row.id;
            this.$router.push({ path: '/community-ArticleEdit', query: { id: row.id } });
        },
        // 状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.confirmVisible = true;
        },
        // 确定下线
        stateData() {
            request.post('/community/edit', this.form).then((ret) => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 复制内容
        copy() {
            let dom = document.getElementById('html');
            let res = clipboard(dom)
                .then((res) => {
                    console.log(res, '复制成功');
                    this.$message.success('复制成功');
                })
                .catch((err) => {
                    console.log('复制失败');
                    this.$message.error('复制失败');
                });
        },

        tagTpey(index) {
            let arr = ['', 'success', 'warning', 'danger', 'info']
            let num = index % 5;
            return arr[num]
        }
    }
};
</script>
<style lang="scss" scoped>
.red {
    color: #ff0000;
}

.head_img {
    width: 48px;
    height: 48px;
    border-radius: 10%;
    margin-right: 4px;
}

.pagination {
    text-align: right;
    margin-top: 10px;
}

.p-title {
    font-size: 18px;
    color: #303133;
    line-height: 24px;
    padding-top: 20px;
    padding-bottom: 10px;
    font-weight: 600;
}

.avatar {
    width: 100px;
    height: 100px;
    font-size: 28px;
    line-height: 100px;
    text-align: center;
}
.list_boxs {
    .list_item {
        display: flex;
        align-items: center;
        margin-bottom: 35px;
        cursor: pointer;
        .img {
            width: 150px;
            height: 80px;
            // background-color: #000;
            margin-right: 15px;
            border-radius: 10px;
        }

        .center_box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 80px;
            .title {
                font-size: 18px;
                color: #000;
                max-width: 1200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .tag {
            }

            .time {
                font-size: 12px;
                color: #666;
            }
        }
    }
}
.detail_box {
    padding: 20px;
    width: 100%;
    .title {
        font-size: 26px;
        margin-top: 10px;
    }

    &::v-deep .weapp_image_link {
        font-size: 0;
        display: inline-block;
        position: relative;
        vertical-align: bottom;
        &::after {
            content: ' ';
            width: 26px;
            height: 26px;
            display: block;
            position: absolute;
            top: 9px;
            right: 9px;
            background: url(data:image/png;base64,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)
                no-repeat center;
            background-size: contain;
            position: absolute;
            right: 20px;
            top: 20px;
        }
        .wxw-img {
            vertical-align: bottom !important;
        }
    }
}
</style>
